// HAMZA: you're in updateGenericDiscountAccountings; write it and call it whenever we create/remove pss

// TODO Hamza: write below functions, and then start calling them
// (DONE) createGenericDiscountAccountings: check applyDiscount method and plug creating generic discount accountings in it or after it
// (DONE) updateGenericDiscountAccountings: check addToBasket inside bue-helpers/product-category.ts and inside PCSelect.vue method (or where we exactly apply existing discount on new pss) and plug updating existing generic discount (not completed) accountings in it or after it
// (DONE) removeGenericDiscountAccountings: removes discount accountings that was created now: accounting isn't completed AND paymentMethod POS_Discount. It gets called when user removes the discount or Change anything about it
// (DONE) in below components use computed properties of this file only
// (DONE) Payment
// (DONE) Booking
// (DONE) AsideOrderSummary
// (DONE) Think about a clean way to make a function out (getPromocodePaymentValue() and getPromocodeDiscountValue()) of the getter promocodeDiscountValue, the function will decide what the pss gets as discount/payment from a given code. It gets used while creating accEntries of the code
// (DONE) createCodePaymentAccountings: it already exists, copy it and just keep new accounting state in Pending, don't complete it now. Triggered when applying the code. Use getPromocodePaymentValue() to get values for accEntries
// (DONE) removeCodePaymentAccountings: triggered by user in Promocode.vue or in AsideOrderSummary. It takes the codeUuid and removes its not-completed accounting
// (DONE) createPromocodeDiscountAccountings: it already exists, copy it. Triggered when applying the code.  Use getPromocodeDiscountValue() to get values for accEntries
// (DONE) removePromocodeDiscountAccountings: triggered by user in Promocode.vue or in AsideOrderSummary. It takes the codeUuid and removes its not-completed accounting
//////////////////////////////////////////// ************************************************
// HOW TO CREATE/REMOVE ACCOUNTINGS:
// Case 1:
// (DONE) Case 1.A: When Applying generic discount:
//     - Remove pending payment code accountings of all applied payment codes
//     - Remove pending discount code accountings of all applied discount codes
//     - Create generic discount accounting
//     - Create discount code accountings of all applied discount codes
//     - Create payment code accountings of all applied payment codes
// (DONE) Case 1.B: When adding / removing PSS:
// (DONE) If(appliedGenericDiscount)
//     - Remove pending payment code accountings of all applied payment codes
//     - Remove pending discount code accountings of all applied discount codes
//     - Update generic discount accounting
//     - Create discount code accountings of all applied discount codes
//     - Create payment code accountings of all applied payment codes
// (DONE) Else:
//     If(discount code applied)
//     - Remove pending payment code accountings of all applied payment codes
//     - Remove pending discount code accountings of all applied discount codes
//     - Create discount code accountings of all applied discount codes
//     - Create payment code accountings of all applied payment codes
// (DONE) Else
//     - Remove pending payment code accountings of all applied payment codes
//     - Create payment code accountings of all applied payment codes
// (DONE) Case 2: When applying discount code
//     - Remove pending payment code accountings of all applied payment codes
//     - Remove pending discount code accountings of all applied discount codes
//     - Create discount code accountings of all applied discount codes
//     - Create payment code accountings of all applied payment codes
// (DONE) Case 3: When applying payment code xyz
//     - Remove pending payment code accounting of applied payment code xyz in case there are any
//     - Create payment code accounting of applied payment code xyz
// (DONE) Test two discount codes in the same booking
// (DONE) Test two payment codes in the same booking
// (DONE) Test payment codes after discount code in the same booking: It creates correct accountigns, but doesn't show the payment we got in Promocode.vue --> We will list discounts/payments in Promocode.vue later
// (DONE) Test discount code after payment code in the same booking: I had an issue where discount code was acting like payment code accounting still exist, I discovered that some computed properties were considering state booking, so I wrote the same code of computed properties but as functions accepting bookingCopy as a parameter (issPssPaidInBooking, ttl payments of pss in booking, ttl discounts of pss in booking)
// (DONE) When applying codes and generating discounts you need to fix: 1- (DONE) restToPay in paymentStep input and in Confirm button 2- (DONE) Show generated code payments (pending accountings) in Order summary 3- (DONE) Show discounts in order summary of all promocodes not only one of them
// (DONE) Generic discount after generic discount is not working fine
// (DONE) Do one discount code after three payment codes, you will see the last giftcard will have an accounting without accountingEntry, we should forbid creating such an accounting
//////////////////////////////////////////// ************************************************

// (DONE) There is an issue with generic discount if it is 100%, it generates an empty acounting
// (DONE) In AsideOrderSummary.vue/removePayment() also remove the applied payment code from the state
// (DONE) When completing the booking, consider restToPay instead of leftToPay or pssSumFinalValues
// (DONE) remove at least the getter bookingLifeTimePSS because it is used by TAX accEntries and we need to rectify it
// (DONE) In PCSelect.vue, confirm button isn't working; I think it is caused by the updateDiscountAccountings logic that I added few days ago
// (HEEEEEERRRRRREEEEEEE) In Promocode.vue remove the old result ui and keep the one I recently added
// BECAREFUL BookingModule.pssListBalances is still used inside the function createRefundPSSAccounting()/completeBooking()/addToBasket()/downloadBadge(); it seems it is only used when the booking is completed, but still becarefull
// (LATER) Add new functions isPaymentCode() and isDiscountCode() and use everywhere instead of having big ifs everywhere
// (LATER) In Promocode.vue: show a list of the applied code with the discount/payment result (like in B2C) and a remove button that removes the accounting of the code if it isn't already synched to backend nor coming from backend

import { ConcurrentTimeEntity } from "@/api/promocodes/promocodes";
import { Currencies } from "@/constants/currency";
import { IPromocodeTrack } from "@/interfaces/store/IBooking";
import { LogLevel, LogService } from "@/services/logging";
import AuthModule from "@/store/modules/auth";
import BookingModule from "@/store/modules/booking";
import CashFloatModule from "@/store/modules/cash-float";
import DeviceModule from "@/store/modules/device";
import {
  AccountingState,
  BlockConcurrectTimeTypes,
  IAccounting,
  PaymentMethods,
  PromocodeCampaignType,
  PromocodeUsage,
  TransactionTypes,
} from "@/types/db/accounting";
import { IAccountingEntry } from "@/types/db/accounting-entry";
import { IProductSlotBooking } from "@/types/db/product-slot-booking";
import {
  BookingStatus,
  IProductSlotState,
  IQuantifiedProductSlotState,
  PaymentStatus,
} from "@/types/db/product-slot-state";
import dayjs from "dayjs";
import { computed } from "vue";
import { generateID } from "../helpers/app";
import { roundToNearestMultipleOf5, sumArray } from "../helpers/common";
import { dateTimeToWeekDay, nowDB } from "../helpers/dates";
import { getPSSValue } from "../helpers/product-slot-state";
import { isToApply } from "./promocode";
import { getpssExtension } from "./booking";
import { getTaxValue } from "../helpers/tax";
import POSConfigModule from "@/store/modules/pos-config";
import { Weekday } from "@/constants/dates";
import FiskalyModule from "@/store/modules/fiskaly";
import { ProductSlotState } from "@/types/gql/generated/graphql";
import { isPssPaid } from "./product-slot-state";

//////////////////////////////////////////////////// FUNCTIONS
//////
//////
//////
//////

/**
 * Takes a booking and remove all accountingEntries of the pss
 * If accounting is left without accountingEntries then we remove it as well
 * @param bookingCopy It is a copy of what we have in state. It is not the booking we have in state.
 * @param pss
 * This function does not remove accountings coming from backend
 * TODO HAMZA: THIS FUNCTION TO IS TO BE DELETED BECAUSE IT SEEMS WE ARE NOT GOING TO USE IT BECAUSE WE ALWAYS updateAccountings inside addToBasket functions
 */
function removePssAccountings(
  bookingCopy: IProductSlotBooking,
  pss: IProductSlotState
) {
  let pssAccountings = bookingCopy.accountings.filter((acc) => {
    const pssAccEntries = acc.accountingEntriesList.filter(
      (ae) =>
        ae.productSlotStateUuid === pss.uuid || ae.productSlotStateId === pss.id
    );
    if (pssAccEntries && pssAccEntries.length > 0) {
      // this acc is linked to the pss
      return true;
    } else {
      // this acc is not linked to the pss
      return false;
    }
  });

  // 0- Update accountings array of the bookingCopy to only have accountings outside pssAccountings
  bookingCopy.accountings = bookingCopy.accountings.filter(
    (acc) => !pssAccountings.map((pssAcc) => pssAcc.uuid).includes(acc.uuid)
  );

  // 1- Remove accountingEntries of the PSS
  for (let i = 0; i < pssAccountings.length; i++) {
    pssAccountings[i].accountingEntriesList = pssAccountings[
      i
    ].accountingEntriesList.filter(
      (ae) => ae.productSlotStateUuid !== pss.uuid
    );
  }

  // 2- Remove empty accountings
  pssAccountings = pssAccountings.filter(
    (acc) => acc.accountingEntriesList.length > 0
  );

  // 4- Update accountings array of the bookingCopy to consider what remained inside pssAccountings
  for (let i = 0; i < pssAccountings.length; i++) {
    bookingCopy.accountings.push(pssAccountings[i]);
  }
}

/**
 * PSS has enough accountingEntries values (discount or payment)
 * or Order is fully covered by payment+discount accountings (state:1 or completed)
 * Think about moving this to ComputedProperties (performance wise)
 */
export function isPSSPaid(pss: IProductSlotState): boolean {
  if (!restToPay.value || restToPay.value < 0) {
    // Order is covered by payments/discounts
    // We consider the pss fully paid
    return true;
  }

  const paymentsOfPss = paymentByPss.value(String(pss.uuid));
  const discountsOfPss = totalDiscountsByPss.value(String(pss.uuid));
  const refundsOfPss = refundsByPss.value(String(pss.uuid));
  const pssValue = getPSSValue(pss);
  if (pssValue <= paymentsOfPss + discountsOfPss + refundsOfPss) {
    return true;
  }
  return false;
}

/**
 * Checks whether the pss is fully paid in the booking obj
 * Needed when we're in the middle of processing accountings and we need to consider an updated copy of the booking obj instead of the one we have in state
 * PSS has enough accountingEntries values (discount or payment)
 * or Order is fully covered by payment+discount accountings (state:1 or completed)
 * Think about moving this to ComputedProperties (performance wise)
 */
export function isPSSPaidInBooking(
  pss: IProductSlotState,
  bookingCopy: IProductSlotBooking
): boolean {
  const rest = restToPayOfBooking(bookingCopy);
  if (!rest || rest < 0) {
    // Order is covered by payments/discounts
    // We consider the pss fully paid
    return true;
  }

  //   const paymentsOfPss = paymentByPss.value(String(pss.uuid));
  //     const discountsOfPss = totalDiscountsByPss.value(String(pss.uuid));
  const paymentsOfPss = paymentByPssInBooking(String(pss.uuid), bookingCopy);
  const discountsOfPss = totalDiscountsByPssInBooking(
    String(pss.uuid),
    bookingCopy
  );
  const refundsOfPss = refundsByPssInBooking(String(pss.uuid), bookingCopy);
  const pssValue = getPSSValue(pss);
  if (pssValue <= paymentsOfPss + discountsOfPss + refundsOfPss) {
    return true;
  }
  return false;
}

/**
 * Triggered when applying the discount
 * Create generic discount accounting (state:1) and accountingEntries for pss that are included in the discount
 * Uses bookingDiscountTrack to decide which pss and how much the discount value is
 */
export function createGenericDiscountAccountings(
  bookingCopy: IProductSlotBooking
) {
  const uuid = generateID();
  const creationTime = dayjs().toISOString();
  const accountingState = AccountingState.Pending;
  const transactionType = TransactionTypes.TRANSACTION_TYPE_DISCOUNT;

  // link the transaction to the new accounting
  const transaction =
    FiskalyModule.transactionsInProgress[String(bookingCopy.uuid)];

  const accounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: accountingState,
    transactionType: transactionType,
    paymentMethod: PaymentMethods.METHODS_POS_DISCOUNT,
    bookingUuid: bookingCopy.uuid,
    promoCodeUuid: null,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: bookingCopy.currency,
    accountingEntriesList: [],
    cashRegisterId: "",
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    fiskalyTransactionUuid: transaction ? transaction.uuid : null,
  };

  // Create accounting entries for the tickets with discount
  // const discountPssList = BookingModule.pssDiscountValues;
  const discountPssList = genericDiscountTracking.value.pssDiscounts;

  for (let i = 0; i < discountPssList.length; i++) {
    // create AE only if the pss still has unaid value
    const pss = bookingCopy.pssList.find(
      (pss) => pss.uuid === discountPssList[i].pssUUID
    );
    if (!pss) {
      // PSS no longer exists in the booking (e.g. removed before discountTracking
      // was rebuilt by updateDiscount). Skip the stale tracking entry.
      continue;
    }

    if (isPSSPaid(pss)) {
      // PSS already paid; it will not be considered in discount accounting
      continue;
    }

    const now = nowDB();
    const accountingEntryValue =
      discountPssList[i].pssOriginalPriceValue -
      discountPssList[i].pssNewPriceValue;
    const accountingEntry: IAccountingEntry = {
      _id: generateID(),
      uuid: generateID(),
      accountingUuid: accounting.uuid,
      orderSessionId: String(BookingModule.currentOrderSessionId),
      productSlotStateUuid: discountPssList[i].pssUUID,
      value: accountingEntryValue,

      groupId: Number(
        bookingCopy.pssList.find((it) => it.uuid === discountPssList[i].pssUUID)
          ?.productOwnerGroupId
      ),
      bookingStatementVersion: 2,
      createdAt: now,
      updatedAt: now,

      productId: Number(
        bookingCopy.pssList.find((it) => it.uuid === discountPssList[i].pssUUID)
          ?.productId
      ),
    };

    if (pss && pss.id) {
      accountingEntry.productSlotStateId = pss.id;
    }

    // new tax logic
    const priceTaxes = getpssExtension(String(pss.uuid))?.taxes || [];
    if (priceTaxes.length) {
      const tax = priceTaxes[0];
      accountingEntry.salesTaxMicroValue = getTaxValue(
        accountingEntry.value,
        tax
      );
      accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
      accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
      accountingEntry.taxId = Number(tax.id);
    }

    if (accountingEntry.value !== 0) {
      // a zero-value entry discounts nothing; keeping it only adds noise to
      // the booking and to the fiscal payload
      accounting.accountingEntriesList.push(accountingEntry);
    }
  }

  if (!accounting.accountingEntriesList.length) {
    return null;
  }
  bookingCopy.accountings.push(accounting);

  return accounting;
}

/**
 * Triggered when creating/removing PSS and booking has a discountTracking object
 * It change in the existing POS_Discount accounting by adding/removing accountingEntries
 * @param bookingCopy
 * @returns
 */
export function updateGenericDiscountAccountings(
  bookingCopy: IProductSlotBooking
) {
  // // First lets check if booking does have a generic discount in the state
  const discountPssList =
    genericDiscountTracking.value && genericDiscountTracking.value.pssDiscounts
      ? genericDiscountTracking.value.pssDiscounts
      : [];
  // if (!discountPssList || !discountPssList.length) {
  //   // booking is not considered in the generic discount, this function shouldn't be triggered from the first place
  //   LogService.info(
  //     `App tried to create generic discount accountings for booking ${bookingCopy.uuid} that does not have generic discount applied`,
  //     undefined,
  //     LogLevel.Error
  //   );
  //   return;
  // }

  // So booking has a generic discount applied in the state
  // Lets check if it has a generic discount accounting
  const genericDiscountAccounting = bookingCopy.accountings.find(
    (acc) =>
      acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT &&
      acc.state === AccountingState.Pending &&
      !acc.refund
  );
  if (!genericDiscountAccounting) {
    // This booking doesn't have a generic discount accounting; this function shouldn't be triggered in the first place
    LogService.info(
      `App tried to create generic discount accountingEntries for booking ${bookingCopy.uuid} that does not have generic discount accounting`,
      undefined,
      LogLevel.Error
    );
    return;
  }

  // 1- Lets check which PSS that is not fully paid and is included in the generic discount so that we create accountingEntries for it
  for (let i = 0; i < discountPssList.length; i++) {
    // create AE only if the pss still has unpaid value
    const pss = bookingCopy.pssList.find(
      (pss) => pss.uuid === discountPssList[i].pssUUID
    );
    if (!pss) {
      // PSS no longer exists in the booking (e.g. removed before discountTracking
      // was rebuilt by updateDiscount). Skip the stale tracking entry.
      continue;
    }
    if (isPSSPaid(pss)) {
      // PSS already paid; we don't create discount accountingEntry for it
      LogService.info(
        `PSS: ${pss.uuid} is fully paid, we don't create its generic discount accountingEntry`
      );
      continue;
    }
    // Lets now check if this pss already has a generic discount accounting entry
    const existingGenericDiscountEntry =
      genericDiscountAccounting.accountingEntriesList.findIndex(
        (ae) => ae.productSlotStateUuid === pss.uuid
      );
    if (existingGenericDiscountEntry > -1) {
      // PSS already has a generic discount accountingEntry
      LogService.info(
        `PSS: ${pss.uuid} is already considered in generic discount accounting, we don't create its generic discount accountingEntry`
      );
      continue;
    }
    // PSS isn't fully paid and doesn't have already generic discount accountingentry, lets create its POS_Discount accountingEntry
    if (
      discountPssList[i].pssNewPriceValue &&
      discountPssList[i].pssOriginalPriceValue
    ) {
      const now = nowDB();
      const accountingEntry: IAccountingEntry = {
        _id: generateID(),
        uuid: generateID(),
        accountingUuid: genericDiscountAccounting.uuid,
        orderSessionId: String(BookingModule.currentOrderSessionId),
        productSlotStateUuid: discountPssList[i].pssUUID,
        value: Number(
          discountPssList[i].pssOriginalPriceValue -
            discountPssList[i].pssNewPriceValue
        ),

        groupId: Number(
          bookingCopy.pssList.find(
            (it) => it.uuid === discountPssList[i].pssUUID
          )?.productOwnerGroupId
        ),
        bookingStatementVersion: 2,
        createdAt: now,
        updatedAt: now,

        productId: Number(
          bookingCopy.pssList.find(
            (it) => it.uuid === discountPssList[i].pssUUID
          )?.productId
        ),
      };

      if (pss && pss.id) {
        accountingEntry.productSlotStateId = pss.id;
      }
      genericDiscountAccounting.accountingEntriesList.push(accountingEntry);
      LogService.info(
        `Done creating generic discount accountingEntry (attached) for PSS: ${pss.uuid}`,
        { params: accountingEntry }
      );
    }
  }

  LogService.info(
    `Done creating generic discount accountingEntries for booking ${bookingCopy.uuid} for new PSSs`
  );

  // 2- If user actually removed some PSS then we remove their POS_Discount accountingEntry
  const accountingEntries = genericDiscountAccounting.accountingEntriesList;
  genericDiscountAccounting.accountingEntriesList = [];
  for (let i = 0; i < accountingEntries.length; i++) {
    // For each accountingEntry we check if we really have its pss or not
    // If no pss found then we remove the accountingEntry
    const pssIndex = bookingCopy.pssList.findIndex(
      (pss) => pss.uuid === accountingEntries[i].productSlotStateUuid
    );
    if (pssIndex < 0) {
      // PSS doesn't exist but its accountingEntry exists
      // lets remove the accountingEntry
      continue;
    }
    // PSS exists, lets keep its generic discount accountingEntry
    genericDiscountAccounting.accountingEntriesList.push(accountingEntries[i]);
  }

  // 3- If at this stage the discount accounting has no accounting entries in it, then we remove it from the booking
  if (genericDiscountAccounting.accountingEntriesList.length === 0) {
    const genericDiscAccUuid = genericDiscountAccounting.uuid;
    const keptAccountings = bookingCopy.accountings.filter(
      (acc) => acc.uuid !== genericDiscAccUuid
    );
    bookingCopy.accountings = keptAccountings;
  }
  LogService.info(
    `Done removing generic discount accountingEntries for booking ${bookingCopy.uuid} for any removed PSS`
  );
}

/**
 * removes discount accountings that was created now: accounting isn't completed AND paymentMethod POS_Discount
 * It gets called when user removes the discount or Change anything about it and apply again (callend always before createGenericDiscountAccountings)
 * @param bookingCopy
 * @returns
 */
export function removeGenericDiscountAccountings(
  bookingCopy: IProductSlotBooking
) {
  const noGenericDiscountAccountings = bookingCopy.accountings.filter((acc) => {
    if (
      acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT &&
      acc.state === AccountingState.Pending
    ) {
      return false;
    }
    return true;
  });
  bookingCopy.accountings = noGenericDiscountAccountings;
}

/**
 * pss.priceValue or pss.accountingValue minus any discount or any payment accountingEntry
 */
export function pssUnpaidValue(pss: IProductSlotState): number {
  if (!restToPay.value || restToPay.value < 0) {
    // Order is covered by payments/discounts
    // We consider the pss fully paid
    return 0;
  }

  const paymentsOfPss = paymentByPss.value(String(pss.uuid));
  const discountsOfPss = totalDiscountsByPss.value(String(pss.uuid));
  const pssExcludedTax = excludedTaxByPss.value(String(pss.uuid));
  const refundsOfPss = refundsByPss.value(String(pss.uuid));
  const pssValue = getPSSValue(pss);
  return (
    pssValue +
    pssExcludedTax +
    pss.paymentFeeCollected -
    (paymentsOfPss + discountsOfPss + refundsOfPss)
  );
}

/**
 * Start times (unix) of all slots the code is already applied to (concurrent-time check).
 * Merges two sources:
 * 1. the backend usage (`blackList.time`, stored as "start-start" strings).
 * 2. slots applied earlier in the current booking (`appliedTimesByCategory`, already unix numbers).
 * Scope is pss category, or every category depending on BlockConcurrectTimeTypes rule
 */
function getCodeUsageStarts(options: {
  blackListTime: { [categoryId: string]: string[] };
  appliedTimesByCategory: { [categoryId: string]: number[] };
  categoryId: number;
  allCategories: boolean;
}): number[] {
  const { blackListTime, appliedTimesByCategory, categoryId, allCategories } =
    options;

  const categories = allCategories
    ? [
        ...new Set([
          ...Object.keys(blackListTime),
          ...Object.keys(appliedTimesByCategory),
        ]),
      ]
    : [String(categoryId)];

  const starts: number[] = [];
  for (const category of categories) {
    for (const range of blackListTime[category] ?? []) {
      starts.push(Number(range.split("-")[0]));
    }
    starts.push(...(appliedTimesByCategory[category] ?? []));
  }
  return starts;
}

/**
 * Check if applying the code to this pss would break the concurrent-time limit
 */
function isPssConcurrentTimeBlocked(options: {
  startDateTime: string;
  categoryId: number;
  blackList: ConcurrentTimeEntity | null;
  blockConcurrentTime: number;
  blockConcurrentTimeDuration: number;
  maxUsagePerUnit: number;
  appliedTimesByCategory: { [categoryId: string]: number[] };
}): boolean {
  const {
    startDateTime,
    categoryId,
    blackList,
    blockConcurrentTime,
    blockConcurrentTimeDuration,
    maxUsagePerUnit,
    appliedTimesByCategory,
  } = options;

  if (
    blockConcurrentTime ===
      BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_NONE ||
    !startDateTime
  ) {
    return false;
  }

  const usedStarts = getCodeUsageStarts({
    blackListTime: blackList?.time ?? {},
    appliedTimesByCategory,
    categoryId,
    allCategories:
      blockConcurrentTime === BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_ALL,
  });

  // Each slot reserve a `blockConcurrentTimeDuration` window (minutes)
  // from its start.
  const windowSeconds = blockConcurrentTimeDuration * 60;
  const currentStart = dayjs(startDateTime).unix();
  const currentEnd = currentStart + windowSeconds;
  const usesInWindow =
    1 +
    usedStarts.filter((comparedStart) => {
      const comparedEnd = comparedStart + windowSeconds;
      return comparedStart <= currentEnd && comparedEnd >= currentStart;
    }).length;

  return usesInWindow > maxUsagePerUnit;
}

/**
 * It takes a list of PSS and returns an array of discounts they will get from applying the code
 * We will use it before creating Promocode Discount accounting to see if we will have discount generated or not
 * We will use it also when creating accountingEntries of Promocode Discount accounting to decide the accEntry.value
 * @param pssList
 */
export function getPromocodeDiscountValue(
  bookingCopy: IProductSlotBooking,
  discountCode: IPromocodeTrack,
  pssListToDiscount?: IProductSlotState[]
): {
  pssUuid: string;
  promocodeDiscountValue: number;
  pssRemainingPriceValue: number;
}[] {
  // TODO HAMZA: here we use the logic that exists inside the getter promocodeDiscountValues and we return the sum of discounts
  ///////////////////////////////////////////////////////////////

  const promocodeDiscounts: {
    pssUuid: string;
    promocodeDiscountValue: number;
    pssRemainingPriceValue: number;
    //   promoCodeId: number | null;
    //   codeTransactionType: CodeTransactionType;
  }[] = [];

  const promocode = discountCode;

  // Values supplied by Saoussene in confluence doc
  const AMOUNT_LIMITED_BY_VALUE_IN_TOTAL = 0;
  const AMOUNT_LIMITED_BY_VALUE_PER_TICKET = 1;

  if (
    promocode.promocode.promoCodeType !==
      PromocodeCampaignType.TYPE_MEMBERSHIP &&
    promocode.promocode.promoCodeType !==
      PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD &&
    promocode.promocode.promoCodeType !== PromocodeCampaignType.TYPE_PROMO_CODE
  ) {
    // this is not a discount code, lets return an empty array
    return promocodeDiscounts;
  }

  const accountings = bookingCopy.accountings || [];
  const pssList = pssListToDiscount || bookingCopy.pssList;
  // const paymentAccountings = accountings.filter(
  //   (acc) =>
  //     (acc.state === AccountingState.Completed ||
  //       acc.state === AccountingState.Pending) &&
  //     !acc.refund &&
  //     acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
  // );

  // get all code accounting entries that are created in this booking session and backend doesn't know about
  // so that we include their value and their length in the calculation of maxUsage and not exceed flatValue
  const existingAccEntriesOfTheCode: IAccountingEntry[] = accountings
    .filter(
      (acc) =>
        (acc.promoCodeId || acc.promoCodeUuid) &&
        ((acc.state === AccountingState.Completed &&
          !acc.id) /*completed AND not coming from backend*/ ||
          acc.state === AccountingState.Pending) &&
        acc.refund !== 1 &&
        // We only consider accEntries of this exact code
        (acc.promoCodeUuid === promocode?.promocode.code ||
          acc.promocode === promocode?.promocode.code)
    )
    .map((acc) => acc.accountingEntriesList)
    .flat();

  // the below are used to check if we can apply the promocode on this pss
  const useOnePer = promocode?.promocode.useOnePer;
  const maxUsagePerUnit = promocode?.promocode.maxUsagePerUnit;
  const blackList =
    promocode?.promocode.blackList && promocode?.promocode.blackList[0]
      ? promocode?.promocode.blackList[0]
      : null;

  const blockConcurrentTime =
    promocode?.promocode.blockConcurrentTime ??
    BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_NONE;
  const blockConcurrentTimeDuration =
    promocode?.promocode.blockConcurrentTimeDuration ?? 0;

  const timeslotsToApply: {
    [id: number]: number;
  } = {};
  const categoriesToApply: {
    [id: number]: number;
  } = {};
  const productsToApply: {
    [id: number]: number;
  } = {};
  // We also consider slots from the current basket
  const appliedTimesByCategory: {
    [categoryId: string]: number[];
  } = {};

  // Morgan's logic here
  for (let i = 0; i < pssList.length; i++) {
    if (
      pssList[i].paymentStatus === PaymentStatus.Completed ||
      isPSSPaidInBooking(pssList[i], bookingCopy)
    ) {
      // This pss is already paid, we will have no result from applying the code on this pss
      continue;
    }

    if (
      pssList[i].bookingStatus === BookingStatus.Canceled ||
      pssList[i].bookingStatus === BookingStatus.Abandoned
    ) {
      // This pss is cancelled, we will have no result from applying the code on this pss
      continue;
    }

    if (
      pssList[i].startDateTime &&
      !promocode.isValidAllDays &&
      !promocode.validDays.includes(
        dateTimeToWeekDay(pssList[i].startDateTime as string) as Weekday
      )
    ) {
      // This pss starts on a day which this promocode cannot be applied to
      continue;
    }

    const timeslotId = pssList[i].timeSlotId;
    const categoryId = pssList[i].categoryId;
    const productId = pssList[i].productId;

    // get the corresponding entity
    // the entity is used to get the pendingUsage and check the blockConcurrentTime
    let unitPendingUsage = 0;
    if (useOnePer === PromocodeUsage.USAGE_PER_TICKET) {
      const concurrentCategoryQuantity = blackList?.entity[categoryId] || 0;
      unitPendingUsage =
        concurrentCategoryQuantity + categoriesToApply[categoryId] || 0;
    } else if (useOnePer === PromocodeUsage.USAGE_PER_TIME_SLOT && timeslotId) {
      const concurrentTimeslotQuantity = blackList?.entity[timeslotId] || 0;
      unitPendingUsage =
        concurrentTimeslotQuantity + timeslotsToApply[timeslotId] || 0;
    } else if (useOnePer === PromocodeUsage.USAGE_PER_PRODUCT) {
      const concurrentProductQuantity = blackList?.entity[productId] || 0;
      unitPendingUsage =
        concurrentProductQuantity + productsToApply[productId] || 0;
    }

    if (maxUsagePerUnit && unitPendingUsage >= maxUsagePerUnit) {
      // we reached the promocode max usage for this unit (category, timeslot or produt)
      continue;
    }

    // skip this pss if the concurrent-time limit blocks it
    if (
      isPssConcurrentTimeBlocked({
        startDateTime: pssList[i].startDateTime as string,
        categoryId,
        blackList,
        blockConcurrentTime,
        blockConcurrentTimeDuration,
        maxUsagePerUnit: maxUsagePerUnit ?? 1,
        appliedTimesByCategory,
      })
    ) {
      continue;
    }

    // const promocodeSubmitTime = promocode.createdAt;

    let pssPromocodeDiscountValue = 0;

    // Now lets calculate pssRemainingValue
    // we don't use the value that the function pssUnpaidValue(pssList[i]) returns
    // because this function consider the booking that we have in the state which its accountings
    // aren't updated yet

    ///////// lets bring pss payment values in the bookingCopy
    const paymentAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
      ) || [];

    const accountingsEntries = paymentAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const pssPaymentAccountingEntries = accountingsEntries.filter(
      (ae) => ae.productSlotStateUuid === pssList[i].uuid
    );

    const pssPaymentsValues = sumArray(
      pssPaymentAccountingEntries.map((ae) => ae.value)
    );
    /////////
    ///////// lets bring pss discounts values (generic and promocodes) in the bookingCopy
    const genericDiscountAndOffersAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
          (acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT ||
            acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER ||
            acc.paymentMethod === PaymentMethods.METHOD_OFFER)
      ) || [];

    const pssGenericDiscountAndOffersAccountingEntries =
      genericDiscountAndOffersAccountings
        .map((acc) => acc.accountingEntriesList)
        .flat()
        .filter((ae) => ae.productSlotStateUuid === pssList[i].uuid);

    const pssGenericDiscountAndOffersValues = sumArray(
      pssGenericDiscountAndOffersAccountingEntries.map((ae) => ae.value)
    );

    const promocodeDiscountAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
          acc.paymentMethod === PaymentMethods.POS_PROMO_CODE
      ) || [];

    const pssPromocodeDiscountAccountingEntries = promocodeDiscountAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat()
      .filter((ae) => ae.productSlotStateUuid === pssList[i].uuid);

    const pssPromocodeDiscountValues = sumArray(
      pssPromocodeDiscountAccountingEntries.map((ae) => ae.value)
    );
    /////////
    const pssDiscountsValues =
      pssGenericDiscountAndOffersValues + pssPromocodeDiscountValues;
    const pssRemainingPriceValue =
      getPSSValue(pssList[i]) - pssDiscountsValues - pssPaymentsValues;

    const flatValue = promocode.promocode.flatValue;
    const percentValue = promocode.promocode.percentValue;
    const pendingValue = Number(promocode.promocode.pendingValue);
    //in this variable we consider all previous pss price to which promocode was applied
    const previousPssPromocodeDiscountSum =
      sumArray(promocodeDiscounts.map((it) => it.promocodeDiscountValue)) +
      sumArray(existingAccEntriesOfTheCode.map((ae) => ae.value));
    //this is amount of promocode coming from backend considering all cases of usage of promocode on frontend
    const amountAvailable =
      flatValue - pendingValue - previousPssPromocodeDiscountSum;

    // const promoCodeId = promocode.promocode.promoCodeId;

    const isUsageUnlimited = promocode.promocode.isUsageUnlimited;
    const isValueUnlimited = promocode.promocode.isValueUnlimited;
    const pendingUsage = promocode.promocode.pendingUsage
      ? Number(promocode.promocode.pendingUsage)
      : 0;
    const maxUsage = promocode.promocode.maxUsage
      ? Number(promocode.promocode.maxUsage)
      : 0;

    if (!isToApply(promocode.promocode, pssList[i])) {
      pssPromocodeDiscountValue = 0;
    } else {
      // lets check if maxUsage reached
      if (isUsageUnlimited === 0 && maxUsage /*&& pendingUsage*/) {
        const backendPendingUsage = pendingUsage ? pendingUsage : 0;
        // lets count how many time this promocode is applied in frontend and see if we reached maxUsage or not
        const frontendUsage =
          promocodeDiscounts.length + existingAccEntriesOfTheCode.length;
        if (frontendUsage + backendPendingUsage + 1 > maxUsage) {
          // so promocode was applied on previous pss and it already reached maxUsage, current pss will not have the promocode applied
          pssPromocodeDiscountValue = 0;
        } else {
          if (flatValue > 0) {
            // So we consider the promocode discount as being of a certain amount of money
            if (isValueUnlimited === AMOUNT_LIMITED_BY_VALUE_PER_TICKET) {
              pssPromocodeDiscountValue = Math.min(
                pssRemainingPriceValue,
                flatValue
              );
            } else {
              pssPromocodeDiscountValue = Math.min(
                amountAvailable,
                pssRemainingPriceValue,
                flatValue
              );
            }
          } else {
            // The promocode discount is a percentage discount
            pssPromocodeDiscountValue = Math.round(
              (pssRemainingPriceValue * percentValue) / 100
            );
          }
        }
      } else {
        // promocode has no maxUsage nor pendingUsage, lets proceed normally
        if (flatValue > 0) {
          // So we consider the promocode discount as being of a certain amount of money
          if (isValueUnlimited === AMOUNT_LIMITED_BY_VALUE_PER_TICKET) {
            pssPromocodeDiscountValue = Math.min(
              pssRemainingPriceValue,
              flatValue
            );
          } else {
            pssPromocodeDiscountValue = Math.min(
              amountAvailable,
              pssRemainingPriceValue,
              flatValue
            );
          }
        } else {
          // The promocode discount is a percentage discount
          pssPromocodeDiscountValue = Math.round(
            (pssRemainingPriceValue * percentValue) / 100
          );
        }
      }

      // increment the usage of the promocode unit (useOnePer)
      if (timeslotId) {
        timeslotsToApply[timeslotId] = (timeslotsToApply[timeslotId] || 0) + 1;
      }
      productsToApply[productId] = (productsToApply[productId] || 0) + 1;
      categoriesToApply[categoryId] = (categoriesToApply[categoryId] || 0) + 1;
      if (
        blockConcurrentTime !==
          BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_NONE &&
        pssList[i].startDateTime
      ) {
        if (!appliedTimesByCategory[categoryId]) {
          appliedTimesByCategory[categoryId] = [];
        }
        appliedTimesByCategory[categoryId].push(
          dayjs(pssList[i].startDateTime).unix()
        );
      }
    }

    // avoid creating accounting entries with value <= 0
    if (pssPromocodeDiscountValue > 0) {
      promocodeDiscounts.push({
        pssUuid: String(pssList[i].uuid),
        promocodeDiscountValue: pssPromocodeDiscountValue,
        pssRemainingPriceValue,
        // promoCodeId,
        // codeTransactionType: codeTransactionType,
      });
    }
  }

  ///////////////////////////////////////////////////////////////
  return promocodeDiscounts;
}

/**
 * It takes a list of PSS and returns the sum of payments they will get from applying the code
 * We will use it before creating Code Payment accounting to see if we will have payment or not
 * We will use it also when creating accountingEntries of Code Payment accounting, we pass one pss at a time in this case
 * @param pssList
 */
export function getPromocodePaymentValue(
  bookingCopy: IProductSlotBooking,
  paymentCode: IPromocodeTrack,
  pssListToDiscount?: IProductSlotState[]
): { pssUuid: string; promocodeDiscountValue: number }[] {
  // TODO HAMZA: here we use the logic that exists inside the getter promocodeDiscountValues and we return the sum of payments
  //   let discount = 0;
  ///////////////////////////////////////////////////////////////

  const promocodeDiscounts: {
    pssUuid: string;
    promocodeDiscountValue: number;
    //   promoCodeId: number | null;
    //   codeTransactionType: CodeTransactionType;
  }[] = [];

  const promocode = paymentCode;

  // Values supplied by Saoussene in confluence doc
  const AMOUNT_LIMITED_BY_VALUE_IN_TOTAL = 0;
  const AMOUNT_LIMITED_BY_VALUE_PER_TICKET = 1;

  if (
    promocode.promocode.promoCodeType ===
      PromocodeCampaignType.TYPE_MEMBERSHIP ||
    promocode.promocode.promoCodeType ===
      PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD ||
    promocode.promocode.promoCodeType === PromocodeCampaignType.TYPE_PROMO_CODE
  ) {
    // this is not a payment code, lets return an empty array
    return promocodeDiscounts;
  }

  const accountings = bookingCopy.accountings || [];
  const pssList = pssListToDiscount || bookingCopy.pssList;
  const paymentAccountings = accountings.filter(
    (acc) =>
      (acc.state === AccountingState.Completed ||
        acc.state === AccountingState.Pending) &&
      !acc.refund &&
      acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
  );
  // get all code accounting entries that are created in this booking session and backend doesn't know about
  // so that we include their value and their length in the calculation of maxUsage and not exceed flatValue
  const existingAccEntriesOfTheCode: IAccountingEntry[] = accountings
    .filter(
      (acc) =>
        (acc.promoCodeId || acc.promoCodeUuid) &&
        ((acc.state === AccountingState.Completed &&
          !acc.id) /*completed AND not coming from backend*/ ||
          acc.state === AccountingState.Pending) &&
        acc.refund !== 1 &&
        // We only consider accEntries of this exact code
        acc.promoCodeUuid === promocode?.promocode.code
    )
    .map((acc) => acc.accountingEntriesList)
    .flat();

  // the below are used to check if we can apply the promocode on this pss
  const useOnePer = promocode?.promocode.useOnePer;
  const maxUsagePerUnit = promocode?.promocode.maxUsagePerUnit;
  const blackList =
    promocode?.promocode.blackList && promocode?.promocode.blackList[0]
      ? promocode?.promocode.blackList[0]
      : null;

  const blockConcurrentTime =
    promocode?.promocode.blockConcurrentTime ??
    BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_NONE;
  const blockConcurrentTimeDuration =
    promocode?.promocode.blockConcurrentTimeDuration ?? 0;

  const timeslotsToApply: {
    [id: number]: number;
  } = {};
  const categoriesToApply: {
    [id: number]: number;
  } = {};
  const productsToApply: {
    [id: number]: number;
  } = {};
  // We also consider slots from the current basket
  const appliedTimesByCategory: {
    [categoryId: string]: number[];
  } = {};

  // Morgan's logic here
  for (let i = 0; i < pssList.length; i++) {
    if (
      pssList[i].paymentStatus === PaymentStatus.Completed ||
      isPSSPaidInBooking(pssList[i], bookingCopy)
    ) {
      // This pss is already paid, we will have no result from applying the code on this pss
      continue;
    }

    if (
      pssList[i].bookingStatus === BookingStatus.Canceled ||
      pssList[i].bookingStatus === BookingStatus.Abandoned
    ) {
      // This pss is cancelled, we will have no result from applying the code on this pss
      continue;
    }

    if (
      pssList[i].startDateTime &&
      !promocode.isValidAllDays &&
      !promocode.validDays.includes(
        dateTimeToWeekDay(pssList[i].startDateTime as string) as Weekday
      )
    ) {
      // This pss starts on a day which this promocode cannot be applied to
      continue;
    }

    const timeslotId = pssList[i].timeSlotId;
    const categoryId = pssList[i].categoryId;
    const productId = pssList[i].productId;

    // get the corresponding entity
    // the entity is used to get the pendingUsage and check the blockConcurrentTime
    let unitPendingUsage = 0;
    if (useOnePer === PromocodeUsage.USAGE_PER_TICKET) {
      const concurrentCategoryQuantity = blackList?.entity[categoryId] || 0;
      unitPendingUsage =
        concurrentCategoryQuantity + categoriesToApply[categoryId] || 0;
    } else if (useOnePer === PromocodeUsage.USAGE_PER_TIME_SLOT && timeslotId) {
      const concurrentTimeslotQuantity = blackList?.entity[timeslotId] || 0;
      unitPendingUsage =
        concurrentTimeslotQuantity + timeslotsToApply[timeslotId] || 0;
    } else if (useOnePer === PromocodeUsage.USAGE_PER_PRODUCT) {
      const concurrentProductQuantity = blackList?.entity[productId] || 0;
      unitPendingUsage =
        concurrentProductQuantity + productsToApply[productId] || 0;
    }

    if (maxUsagePerUnit && unitPendingUsage >= maxUsagePerUnit) {
      // we reached the promocode max usage for this unit (category, timeslot or produt)
      continue;
    }

    // skip this pss if the concurrent-time limit blocks it
    if (
      isPssConcurrentTimeBlocked({
        startDateTime: pssList[i].startDateTime as string,
        categoryId,
        blackList,
        blockConcurrentTime,
        blockConcurrentTimeDuration,
        maxUsagePerUnit: maxUsagePerUnit ?? 1,
        appliedTimesByCategory,
      })
    ) {
      continue;
    }

    const promocodeSubmitTime = promocode.createdAt;

    let pssPromocodeDiscountValue = 0;

    // Now lets calculate pssRemainingValue
    // we don't use the value that the function pssUnpaidValue(pssList[i]) returns
    // because this function consider the booking that we have in the state which its accountings
    // aren't updated yet

    ///////// lets bring pss payment values in the bookingCopy
    const paymentAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
      ) || [];

    const accountingsEntries = paymentAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const pssPaymentAccountingEntries = accountingsEntries.filter(
      (ae) => ae.productSlotStateUuid === pssList[i].uuid
    );

    const pssPaymentsValues = sumArray(
      pssPaymentAccountingEntries.map((ae) => ae.value)
    );
    /////////
    ///////// lets bring pss discounts values (generic and promocodes) in the bookingCopy
    const genericDiscountAndOffersAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
          (acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT ||
            acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER ||
            acc.paymentMethod === PaymentMethods.METHOD_OFFER)
      ) || [];

    const pssGenericDiscountAndOffersAccountingEntries =
      genericDiscountAndOffersAccountings
        .map((acc) => acc.accountingEntriesList)
        .flat()
        .filter((ae) => ae.productSlotStateUuid === pssList[i].uuid);

    const pssGenericDiscountAndOffersValues = sumArray(
      pssGenericDiscountAndOffersAccountingEntries.map((ae) => ae.value)
    );

    const promocodeDiscountAccountings =
      bookingCopy.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
          acc.paymentMethod === PaymentMethods.POS_PROMO_CODE
      ) || [];

    const pssPromocodeDiscountAccountingEntries = promocodeDiscountAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat()
      .filter((ae) => ae.productSlotStateUuid === pssList[i].uuid);

    const pssPromocodeDiscountValues = sumArray(
      pssPromocodeDiscountAccountingEntries.map((ae) => ae.value)
    );
    /////////
    const pssDiscountsValues =
      pssGenericDiscountAndOffersValues + pssPromocodeDiscountValues;
    const pssRemainingPriceValue =
      getPSSValue(pssList[i]) - pssDiscountsValues - pssPaymentsValues;

    const flatValue = promocode.promocode.flatValue;
    const percentValue = promocode.promocode.percentValue;
    const pendingValue = Number(promocode.promocode.pendingValue);
    //in this variable we consider all previous pss price to which promocode was applied
    const previousPssPromocodeDiscountSum =
      sumArray(promocodeDiscounts.map((it) => it.promocodeDiscountValue)) +
      sumArray(existingAccEntriesOfTheCode.map((ae) => ae.value));
    //this is amount of promocode coming from backend considering all cases of usage of promocode on frontend
    const amountAvailable =
      flatValue - pendingValue - previousPssPromocodeDiscountSum;

    const promoCodeId = promocode.promocode.promoCodeId;

    const isUsageUnlimited = promocode.promocode.isUsageUnlimited;
    const isValueUnlimited = promocode.promocode.isValueUnlimited;
    const pendingUsage = promocode.promocode.pendingUsage
      ? Number(promocode.promocode.pendingUsage)
      : 0;
    const maxUsage = promocode.promocode.maxUsage
      ? Number(promocode.promocode.maxUsage)
      : 0;

    if (!isToApply(promocode.promocode, pssList[i])) {
      pssPromocodeDiscountValue = 0;
    } else {
      // lets check if maxUsage reached
      if (isUsageUnlimited === 0 && maxUsage /*&& pendingUsage*/) {
        const backendPendingUsage = pendingUsage ? pendingUsage : 0;
        // lets count how many time this promocode is applied in frontend and see if we reached maxUsage or not
        const frontendUsage =
          promocodeDiscounts.length + existingAccEntriesOfTheCode.length;
        if (frontendUsage + backendPendingUsage + 1 > maxUsage) {
          // so promocode was applied on previous pss and it already reached maxUsage, current pss will not have the promocode applied
          pssPromocodeDiscountValue = 0;
        } else {
          if (flatValue > 0) {
            // So we consider the promocode discount as being of a certain amount of money
            if (isValueUnlimited === AMOUNT_LIMITED_BY_VALUE_PER_TICKET) {
              pssPromocodeDiscountValue = Math.min(
                pssRemainingPriceValue,
                flatValue
              );
            } else {
              pssPromocodeDiscountValue = Math.min(
                amountAvailable,
                pssRemainingPriceValue,
                flatValue
              );
            }
          } else {
            // The promocode discount is a percentage discount
            pssPromocodeDiscountValue = Math.round(
              (pssRemainingPriceValue * percentValue) / 100
            );
          }
        }
      } else {
        // promocode has no maxUsage nor pendingUsage, lets proceed normally
        if (flatValue > 0) {
          // So we consider the promocode discount as being of a certain amount of money
          if (isValueUnlimited === AMOUNT_LIMITED_BY_VALUE_PER_TICKET) {
            pssPromocodeDiscountValue = Math.min(
              pssRemainingPriceValue,
              flatValue
            );
          } else {
            pssPromocodeDiscountValue = Math.min(
              amountAvailable,
              pssRemainingPriceValue,
              flatValue
            );
          }
        } else {
          // The promocode discount is a percentage discount
          pssPromocodeDiscountValue = Math.round(
            (pssRemainingPriceValue * percentValue) / 100
          );
        }
      }

      // increment the usage of the promocode unit (useOnePer)
      if (timeslotId) {
        timeslotsToApply[timeslotId] = (timeslotsToApply[timeslotId] || 0) + 1;
      }
      productsToApply[productId] = (productsToApply[productId] || 0) + 1;
      categoriesToApply[categoryId] = (categoriesToApply[categoryId] || 0) + 1;
      if (
        blockConcurrentTime !==
          BlockConcurrectTimeTypes.BLOCK_CONCURENT_TIME_NONE &&
        pssList[i].startDateTime
      ) {
        if (!appliedTimesByCategory[categoryId]) {
          appliedTimesByCategory[categoryId] = [];
        }
        appliedTimesByCategory[categoryId].push(
          dayjs(pssList[i].startDateTime).unix()
        );
      }
    }

    // avoid creating accounting entries with value <= 0
    if (pssPromocodeDiscountValue > 0) {
      promocodeDiscounts.push({
        pssUuid: String(pssList[i].uuid),
        promocodeDiscountValue: pssPromocodeDiscountValue,
        // promoCodeId,
        // codeTransactionType: codeTransactionType,
      });
    }
  }

  ///////////////////////////////////////////////////////////////
  return promocodeDiscounts;
}

/**
 * Takes a bookingCopy obj and a payment code and generate a payment accounting for it
 */
export function createPaymentCodeAccounting(
  bookingCopy: IProductSlotBooking,
  code: IPromocodeTrack,
  pssList?: IProductSlotState[]
) {
  const promocode = code.promocode;
  // We don't create an accounting if the code isn't generating a payment
  const payments = getPromocodePaymentValue(bookingCopy, code, pssList);
  const sumOfPayments = sumArray(payments.map((p) => p.promocodeDiscountValue));
  if (sumOfPayments) {
    const uuid = generateID();
    const creationTime = dayjs().toISOString();
    const accountingState = AccountingState.Pending;
    const transactionType = TransactionTypes.TRANSACTION_TYPE_PAYMENT;

    let paymentMethod = "";
    switch (promocode.promoCodeType) {
      case PromocodeCampaignType.TYPE_VOUCHER:
      case PromocodeCampaignType.TYPE_VOUCHER_SOLD:
        paymentMethod = PaymentMethods.POS_VOUCHER;
        break;
      case PromocodeCampaignType.TYPE_GIFT_CARD:
      case PromocodeCampaignType.TYPE_GIFT_CARD_SOLD:
        paymentMethod = PaymentMethods.POS_GIFT_CARD;
        break;
    }

    // link the transaction to the new accounting
    const transaction =
      FiskalyModule.transactionsInProgress[String(bookingCopy.uuid)];

    const promocodePaymentAccounting: IAccounting = {
      _id: uuid,
      uuid: uuid,
      orderSessionId: String(BookingModule.currentOrderSessionId),
      state: accountingState,
      transactionType: transactionType,
      paymentMethod: paymentMethod as PaymentMethods,
      bookingUuid: bookingCopy.uuid,
      promoCodeId: promocode.promoCodeId,
      promoCodeUuid: promocode.code,
      createdAt: creationTime,
      updatedAt: creationTime,
      message: creationTime + " :: accounting was created.",
      isDeposit: false,
      currency: bookingCopy.currency,
      accountingEntriesList: [],
      cashRegisterId: DeviceModule.cashRegisterId,
      channel: "Smeetz POS",
      merchantReference: "",
      CfUid: CashFloatModule.cashFloat?.uid,
      createdBy: AuthModule.cognitoId,
      promocode: promocode.code,
      fiskalyTransactionUuid: transaction ? transaction.uuid : null,
    };

    // Lets now create accounting entries for pss objects that get a payment of the code
    //   const payments = getPromocodePaymentValue(bookingCopy, code);
    for (const codePayment of payments) {
      if (!codePayment.promocodeDiscountValue) {
        // no payment generated, so lets not create an accountingEntry with value 0
        continue;
      }
      // lets create an accEntry for this payment and add it to accounting
      ////////
      const entryCreationTime = dayjs().toISOString();
      const pss = bookingCopy.pssList.find(
        (ps) => ps.uuid === codePayment.pssUuid
      );
      const groupId = pss?.productOwnerGroupId || null;
      const productId = pss?.productId || null;
      const accountingEntry: IAccountingEntry = {
        _id: generateID(),
        uuid: generateID(),
        accountingUuid: promocodePaymentAccounting.uuid,
        orderSessionId: String(BookingModule.currentOrderSessionId),
        productSlotStateUuid: codePayment.pssUuid,
        value: codePayment.promocodeDiscountValue,
        groupId: groupId,
        bookingStatementVersion: 2,
        createdAt: entryCreationTime,
        updatedAt: entryCreationTime,
        productId: Number(productId),
      };
      if (pss && pss?.id) {
        accountingEntry.productSlotStateId = pss.id;
      }

      // new tax logic
      const priceTaxes = getpssExtension(String(pss?.uuid))?.taxes || [];
      if (priceTaxes.length) {
        const tax = priceTaxes[0];
        // We do not assign the field salesTaxMicroValue a value in Payment transaction accountings
        // accountingEntry.salesTaxMicroValue = getTaxValue(
        //   accountingEntry.value,
        //   tax
        // );
        accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
        accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
        accountingEntry.taxId = Number(tax.id);
      }
      promocodePaymentAccounting.accountingEntriesList.push(accountingEntry);
      ////////
    }
    LogService.info(
      `Promocode payment accounting created, booking: ${bookingCopy.uuid}, accounting: ${promocodePaymentAccounting.uuid}`,
      {
        accounting: promocodePaymentAccounting,
        promocodePSS: payments,
      }
    );
    bookingCopy.accountings.push(promocodePaymentAccounting);
  }
}

/**
 * removes payment code pending accountings based on the code we pass
 * @param bookingCopy
 */
export function removePaymentCodePendingAccountings(
  bookingCopy: IProductSlotBooking,
  code: IPromocodeTrack
) {
  const noPaymentCodePendingAccountings = bookingCopy.accountings.filter(
    (acc) => {
      if (
        (acc.promoCodeUuid === code.promocode.code ||
          acc.promocode === code.promocode.code) &&
        acc.state === AccountingState.Pending &&
        !acc.isExternalVoucherService
      ) {
        return false;
      }
      return true;
    }
  );
  bookingCopy.accountings = noPaymentCodePendingAccountings;
}

/**
 * removes payment codes pending accountings
 * @param bookingCopy
 */
export function removeAllPaymentCodePendingAccountings(
  bookingCopy: IProductSlotBooking
) {
  const noPaymentCodePendingAccountings = bookingCopy.accountings.filter(
    (acc) => {
      if (
        (acc.promoCodeUuid || acc.promocode) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
        !acc.refund &&
        acc.state === AccountingState.Pending &&
        !acc.isExternalVoucherService
      ) {
        return false;
      }
      return true;
    }
  );
  bookingCopy.accountings = noPaymentCodePendingAccountings;
}

/**
 * Make payment code pending accountings as cancelled
 */
export function setAllPaymentCodePendingAccountingsAsCancelled(
  bookingCopy: IProductSlotBooking
) {
  bookingCopy.accountings.forEach((acc) => {
    if (
      (acc.promoCodeUuid || acc.promocode) &&
      acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
      !acc.refund &&
      acc.state === AccountingState.Pending &&
      !acc.isExternalVoucherService
    ) {
      acc.state = AccountingState.Cancelled;
    }
  });
}

/**
 * Returns the sum of generated accountings after applying a give code
 */
export function getSumOfCodeGeneratedAccountingsValues(code: string): number {
  let generatedAccountingsSum = 0;
  const generatedAccountings =
    BookingModule.selectedBooking?.accountings.filter(
      (acc) =>
        acc.state === AccountingState.Pending &&
        !acc.refund &&
        (acc.promocode === code || acc.promoCodeUuid === code)
    );
  if (generatedAccountings && generatedAccountings.length) {
    generatedAccountingsSum = sumArray(
      generatedAccountings
        .map((acc) => acc.accountingEntriesList)
        .flat()
        .map((ae) => ae.value)
    );
  }

  return generatedAccountingsSum;
}

/**
 * Takes a bookingCopy obj and a discount code and generate a discount accounting for it
 */
export function createDiscountCodeAccounting(
  bookingCopy: IProductSlotBooking,
  discountCode: IPromocodeTrack,
  pssList?: IProductSlotState[]
) {
  const discounts = getPromocodeDiscountValue(
    bookingCopy,
    discountCode,
    pssList
  );

  const sumOfDiscounts = sumArray(
    discounts.map((d) => d.promocodeDiscountValue)
  );
  if (!sumOfDiscounts) {
    // no discount generated, so lets not create an accounting
    return;
  }

  const promocode = discountCode.promocode;
  const uuid = generateID();
  const creationTime = dayjs().toISOString();
  const accountingState = AccountingState.Pending;
  const transactionType = TransactionTypes.TRANSACTION_TYPE_DISCOUNT;

  let paymentMethod = "";
  switch (promocode.promoCodeType) {
    case PromocodeCampaignType.TYPE_PROMO_CODE:
      paymentMethod = PaymentMethods.POS_PROMO_CODE;
      break;
    case PromocodeCampaignType.TYPE_MEMBERSHIP:
    case PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD:
      paymentMethod = PaymentMethods.POS_MEMBERSHIP;
      break;
  }

  const promocodeDiscountAccounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: accountingState,
    transactionType: transactionType,
    paymentMethod: paymentMethod as PaymentMethods,
    bookingUuid: bookingCopy.uuid,
    promoCodeId: promocode.promoCodeId,
    promoCodeUuid: promocode.code,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: bookingCopy.currency,
    accountingEntriesList: [],
    cashRegisterId: DeviceModule.cashRegisterId,
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    promocode: promocode.code,
  };

  // Skip the CHF rounding when the discount covers the full remaining price:
  // rounding it would leave a 0.01/0.02 balance that can never be paid (L3-7899)
  const discountSettlesItsLines = discounts.every(
    (d) => d.promocodeDiscountValue === d.pssRemainingPriceValue
  );

  // Lets now create accounting entries for pss objects that get a payment of the code
  let promocodeDiscountValueSum = 0;
  for (let i = 0; i < discounts.length; i++) {
    const codeDiscount = discounts[i];
    // lets create an accEntry for this discount and add it to accounting
    if (!codeDiscount.promocodeDiscountValue) {
      // no payment generated, so lets not create an accountingEntry with value 0
      continue;
    }
    ////////
    const entryCreationTime = dayjs().toISOString();
    const pss = bookingCopy.pssList.find(
      (ps) => ps.uuid === codeDiscount.pssUuid
    );
    const groupId = pss?.productOwnerGroupId || null;
    const productId = pss?.productId || null;
    let promocodeDiscountValue = codeDiscount.promocodeDiscountValue;
    promocodeDiscountValueSum += promocodeDiscountValue;
    // roundDiscountValue will determine whether this discount value should be changed or not
    // in order to have a sum of discounts value be a multiple of 5
    let roundDiscountValue = false;
    if (bookingCopy.currency == Currencies.CHF && !discountSettlesItsLines) {
      if (i === discounts.length - 1) {
        // if this is the last discount we have, it should be changed
        roundDiscountValue = true;
      } else {
        // otherwise we check if the next discounts in queue have no payments generated
        // which means that this discount value is technically the last one and should be changed
        roundDiscountValue = true;
        for (let j = i + 1; j < discounts.length; j++) {
          if (discounts[j].promocodeDiscountValue) {
            roundDiscountValue = false;
            break;
          }
        }
      }
    }
    // roundDiscountValue in this case is equivalent to (isLastDiscountValue OR areNextDiscountValuesAllEmpty)
    if (roundDiscountValue) {
      // Change the last discount value to a have a total sum of discounts be a multiple of 5 for CHF transactions
      // rounded sum of discount values
      const roundedPromocodeDiscountValueSum = roundToNearestMultipleOf5(
        promocodeDiscountValueSum
      );
      // calculate the difference between what we want and what we have
      const difference =
        roundedPromocodeDiscountValueSum - promocodeDiscountValueSum;
      // add the difference to the last promocode discount value
      promocodeDiscountValue += difference;
    }
    const accountingEntry: IAccountingEntry = {
      _id: generateID(),
      uuid: generateID(),
      accountingUuid: promocodeDiscountAccounting.uuid,
      orderSessionId: String(BookingModule.currentOrderSessionId),
      productSlotStateUuid: codeDiscount.pssUuid,
      value: promocodeDiscountValue,
      groupId: groupId,
      bookingStatementVersion: 2,
      createdAt: entryCreationTime,
      updatedAt: entryCreationTime,
      productId: Number(productId),
    };
    if (pss && pss?.id) {
      accountingEntry.productSlotStateId = pss.id;
    }
    // new tax logic
    const priceTaxes = getpssExtension(String(pss?.uuid))?.taxes || [];
    if (priceTaxes.length) {
      const tax = priceTaxes[0];
      accountingEntry.salesTaxMicroValue = getTaxValue(
        accountingEntry.value,
        tax
      );
      accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
      accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
      accountingEntry.taxId = Number(tax.id);
    }

    promocodeDiscountAccounting.accountingEntriesList.push(accountingEntry);

    // if the code is a membership voucher and oneTokenVoucherTickets is disabled, then we don't update the token
    // if there's another membership voucher applied on this pss, then we don't update the token
    // if this pss is coming from backend, then we don't update the token
    // if the pss is confirmed (user was able to print the ticket with the original token of this pss), then we don't update the token
    if (
      POSConfigModule.groupInfo?.oneTokenVoucherTickets === 1 &&
      (promocode.promoCodeType === PromocodeCampaignType.TYPE_MEMBERSHIP ||
        promocode.promoCodeType ===
          PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD ||
        promocode.promoCodeType === PromocodeCampaignType.TYPE_GIFT_CARD ||
        promocode.promoCodeType ===
          PromocodeCampaignType.TYPE_GIFT_CARD_SOLD) &&
      discountCode.token &&
      pss &&
      !pss.id &&
      pss.bookingStatus !== BookingStatus.Confirmed &&
      !pss.appliedMembershipToken
    ) {
      pss.appliedMembershipToken = discountCode.token;
    }
  }
  LogService.info(
    `Promocode discount accounting created, booking: ${bookingCopy.uuid}, accounting: ${promocodeDiscountAccounting.uuid}`,
    {
      accounting: promocodeDiscountAccounting,
      promocodePSS: discounts,
    }
  );
  bookingCopy.accountings.push(promocodeDiscountAccounting);
}

/**
 * removes discount code pending accountings
 * @param bookingCopy
 */
export function removeDiscountCodePendingAccountings(
  bookingCopy: IProductSlotBooking,
  code: IPromocodeTrack
) {
  const noDiscountCodePendingAccountings = bookingCopy.accountings.filter(
    (acc) => {
      if (
        (acc.promoCodeUuid === code.promocode.code ||
          acc.promocode === code.promocode.code) &&
        acc.state === AccountingState.Pending
      ) {
        return false;
      }
      return true;
    }
  );
  bookingCopy.accountings = noDiscountCodePendingAccountings;
}

/**
 * removes discount codes pending accountings
 * @param bookingCopy
 */
export function removeAllDiscountCodePendingAccountings(
  bookingCopy: IProductSlotBooking
) {
  console.log("----------- removeAllDiscountCodePendingAccountings");
  const noDiscountCodePendingAccountings = bookingCopy.accountings.filter(
    (acc) => {
      if (
        (acc.promoCodeUuid || acc.promocode) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
        !acc.refund &&
        acc.state === AccountingState.Pending
      ) {
        return false;
      }
      return true;
    }
  );
  bookingCopy.accountings = noDiscountCodePendingAccountings;
}

/**
 * Make discount code pending accountings as cancelled
 */
export function setAllDiscountCodePendingAccountingsAsCancelled(
  bookingCopy: IProductSlotBooking
) {
  bookingCopy.accountings.forEach((acc) => {
    if (
      (acc.promoCodeUuid || acc.promocode) &&
      acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
      !acc.refund &&
      acc.state === AccountingState.Pending
    ) {
      acc.state = AccountingState.Cancelled;
    }
  });
}

//////////////////////////////////////////////////// COMPUTED PROPERTIES
//////
//////
//////
//////

/**
 * returns generic discount tracking of the selected booking
 */
export const genericDiscountTracking = computed(() => {
  return BookingModule.bookingsDiscountsTrack[
    BookingModule.selectedBookingUUID
  ];
});

/**
 * returns the selected booking has a an applied generic discount tracking in the state or not
 */
export const hasAppliedGenericDiscountTracking = computed(() => {
  const genericDiscountTracking =
    BookingModule.bookingsDiscountsTrack[BookingModule.selectedBookingUUID];
  if (genericDiscountTracking && genericDiscountTracking.isApplied) {
    return true;
  }
  return false;
});

/**
 * sum of not cancelled pss priceValues
 */
export const bookingTotalIgnoringDiscounts = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  // We exclude cancelled pss
  const notCancelledPssList = booking.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  if (!notCancelledPssList || !notCancelledPssList.length) {
    return 0;
  }
  const pssSum = sumArray(
    notCancelledPssList.map((pss) => {
      const pssValue = getPSSValue(pss);
      return pssValue;
    })
  );

  return pssSum;
});

/**
 * sum of not cancelled pss priceValues minus
 * sum of accountingEntries values of discount Type accountings (state:1 or completed)
 */
export const bookingTotalConsideringDiscounts = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  // We exclude cancelled pss
  const notCancelledPssList = booking.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  if (!notCancelledPssList || !notCancelledPssList.length) {
    return 0;
  }
  const pssSum = Math.round(
    sumArray(
      notCancelledPssList.map(
        (pss) =>
          getPSSValue(pss) +
          excludedTaxByPss.value(String(pss.uuid)) +
          pss.paymentFeeCollected
      )
    )
  );

  // We exclude refund accountings because we excluded cancelled pss
  const discountAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT
    ) || [];
  const discountAccountingsEntries = discountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();
  const discountSum = sumArray(
    discountAccountingsEntries.map((ae) => ae.value)
  );
  return pssSum - discountSum;
});

/**
 * A booking is considered FREE if their tickets are free or is fully discounted
 */
export const isBookingFree = computed(() => {
  const notCancelledPssList = BookingModule.selectedBooking?.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  if (!notCancelledPssList || !notCancelledPssList.length) {
    // Both totals below are 0 for a booking with nothing left in it, which
    // would otherwise read as "free" and have a FREE accounting created for it.
    return false;
  }
  if (
    bookingTotalIgnoringDiscounts.value === 0 ||
    bookingTotalConsideringDiscounts.value <= 0
  ) {
    return true;
  }
  return false;
});

/**
 * sum of not cancelled pss priceValues minus
 * sum of accountingEntries values of discount type accountings and payment type accountings:
 * ((state:1 AND not coming from backend) OR completed)
 */
export const restToPay = computed(() => {
  // console.log("------- hi from restToPay");
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  // We exclude cancelled pss
  const notCancelledPssList = booking.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  const pssSum = Math.round(
    sumArray(
      notCancelledPssList.map((pss) => {
        // Otherwise we use the normal calculation, pss value + excluded tax + payment fee collected
        return (
          getPSSValue(pss) +
          excludedTaxByPss.value(String(pss.uuid)) +
          pss.paymentFeeCollected
        );
      })
    )
  );

  // We exclude refund done for cancelled pss
  const discountAndPaymentAccountings =
    booking.accountings.filter(
      (acc) =>
        ((acc.state === AccountingState.Pending &&
          !acc.id &&
          acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN) ||
          (acc.state === AccountingState.Started &&
            !acc.id &&
            acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN) ||
          acc.state === AccountingState.Completed) &&
        (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND)
    ) || [];
  const accountingsEntries = discountAndPaymentAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();
  const discountAndPaymentSum = sumArray(
    accountingsEntries.map((ae) => ae.value)
  );

  return pssSum - discountAndPaymentSum;
});

/**
 * sum of not cancelled pss priceValues minus
 * sum of accountingEntries values of discount type accountings and payment type accountings:
 * ((state:1 AND not coming from backend) OR completed)
 */
export const restToPayForInvoice = computed(() => {
  // console.log("------- hi from restToPay");
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  // We exclude cancelled pss
  const notCancelledPssList = booking.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  //   if (!notCancelledPssList || !notCancelledPssList.length) {
  //     return 0;
  //   }
  const pssSum = Math.round(
    sumArray(
      notCancelledPssList.map(
        (pss) =>
          getPSSValue(pss) +
          excludedTaxByPss.value(String(pss.uuid)) +
          pss.paymentFeeCollected
      )
    )
  );
  // console.log("------ pssSum");
  // console.log(pssSum);

  // We exclude refund done for cancelled pss
  const discountAndPaymentAccountings =
    booking.accountings.filter(
      (acc) =>
        ((acc.state === AccountingState.Pending &&
          !acc.id &&
          acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN &&
          acc.paymentMethod !==
            PaymentMethods.METHOD_Swiss_QR_Code_Bank_Transfer) ||
          (acc.state === AccountingState.Started &&
            !acc.id &&
            acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN &&
            acc.paymentMethod !==
              PaymentMethods.METHOD_Swiss_QR_Code_Bank_Transfer) ||
          acc.state === AccountingState.Completed) &&
        (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND)
    ) || [];
  const accountingsEntries = discountAndPaymentAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();
  const discountAndPaymentSum = sumArray(
    accountingsEntries.map((ae) => ae.value)
  );
  // console.log("------ discountAndPaymentSum");
  // console.log(discountAndPaymentSum);

  return pssSum - discountAndPaymentSum;
});

/**
 * Calculates the restToPay of a given booking
 * Needed when we're in the middle of processing accountings and we pass a copy of the booking obj
 * sum of not cancelled pss priceValues minus
 * sum of accountingEntries values of discount type accountings and payment type accountings (state:1 or completed)
 */
export function restToPayOfBooking(bookingCopy: IProductSlotBooking) {
  const booking = bookingCopy;
  if (!booking) {
    return 0;
  }
  // We exclude cancelled pss
  const notCancelledPssList = booking.pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned
  );
  //   if (!notCancelledPssList || !notCancelledPssList.length) {
  //     return 0;
  //   }

  // we add the excluded tax amount: pssValue = priceValue + excludedTax + paymentFeeCollected
  const pssSum = Math.round(
    sumArray(
      notCancelledPssList.map(
        (pss) =>
          getPSSValue(pss) +
          excludedTaxByPssInBooking.value(String(pss.uuid), booking) +
          pss.paymentFeeCollected
      )
    )
  );

  // We exclude refund done for cancelled pss
  const discountAndPaymentAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          (acc.state === AccountingState.Started &&
            acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN) ||
          acc.state === AccountingState.Completed) &&
        (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND)
    ) || [];
  const accountingsEntries = discountAndPaymentAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();
  const discountAndPaymentSum = sumArray(
    accountingsEntries.map((ae) => ae.value)
  );

  return pssSum - discountAndPaymentSum;
}

/**
 * sum of accountingEntries values of discount Type accountings and paymentMethod:DISCOUNT (state:1 or completed)
 * refund is included since we refund with Discount what was paid with Discount
 */
export const genericDiscountTotal = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const genericDiscountAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
        acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT
    ) || [];
  const accountingsEntries = genericDiscountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const sum = sumArray(accountingsEntries.map((ae) => ae.value));

  return sum;
});

/**
 * sum of accountingEntries values of discount Type accountings and paymentMethod:POS_PROMO_CODE (state:1 or completed)
 * refund is included since we refund with promocodeDiscount what was paid with promocodeDiscount
 */
export const promocodeDiscountTotal = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const promocodeDiscountAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
        acc.paymentMethod === PaymentMethods.POS_PROMO_CODE
    ) || [];
  const accountingsEntries = promocodeDiscountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const sum = sumArray(accountingsEntries.map((ae) => ae.value));

  return sum;
});

export const offerDiscountTotal = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const offerDiscountAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
        (acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER ||
          acc.paymentMethod === PaymentMethods.METHOD_OFFER)
    ) || [];
  const accountingsEntries = offerDiscountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const sum = sumArray(accountingsEntries.map((ae) => ae.value));

  return sum;
});

/**
 * genericDiscountTotal + promocodeDiscountTotal + offerDiscountTotal
 */
export const discountTotal = computed(() => {
  return (
    genericDiscountTotal.value +
    promocodeDiscountTotal.value +
    offerDiscountTotal.value
  );
});

/**
 * sum of accountingEntries values of payment Type accountings and has promocodeId or promocodeUuid (state:1 or completed)
 * refund is included since we refund with paymentCode what was paid with paymentCode
 */
export const paymentCodesTotal = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const paymentCodesAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
        (acc.promoCodeId || acc.promocode || acc.promoCodeUuid)
    ) || [];
  const accountingsEntries = paymentCodesAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const sum = sumArray(accountingsEntries.map((ae) => ae.value));

  return sum;
});

/**
 * sum of accountingEntries values of Discount transaction and Payment transaction accountings (state:1 or completed)
 * refund is included
 */
export const paymentAndDiscountTotal = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }

  const paymentAndDiscountAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT ||
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT)
    ) || [];
  const accountingsEntries = paymentAndDiscountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const sum = sumArray(accountingsEntries.map((ae) => ae.value));

  return sum;
});

/**
 * sum of accountingEntries values of payment Type accountings and promocodeId === promocodeId (state:1 or completed)
 * refund is included since we refund with paymentCode what was paid with paymentCode
 */
export const paymentTotalByCode = computed((/*promocodeUuid: string*/) => {
  // We return a function that will do the computation. The function expects an argument
  return (promocodeUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    const paymentCodeAccountings =
      booking.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
          (acc.promocode === promocodeUuid ||
            acc.promoCodeUuid === promocodeUuid)
      ) || [];
    const accountingsEntries = paymentCodeAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const sum = sumArray(accountingsEntries.map((ae) => ae.value));

    return sum;
  };
});

/**
 * sum of accountingEntries values of discount Type accountings and promocodeId === promocodeId (state:1 or completed)
 * refund is included since we refund with paymentCode what was paid with paymentCode
 */
export const discountTotalByCode = computed((/*promocodeUuid: string*/) => {
  // We return a function that will do the computation. The function expects an argument
  return (promocodeUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    const discountCodeAccountings =
      booking.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
          (acc.promocode === promocodeUuid ||
            acc.promoCodeUuid === promocodeUuid)
      ) || [];
    const accountingsEntries = discountCodeAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const sum = sumArray(accountingsEntries.map((ae) => ae.value));

    return sum;
  };
});

/**
 * genericDiscountsByPss + promocodeDiscountsByPss + offerDiscountByPSS
 */
/**
 * Sum of the discount accounting entries attached to a pss, over whatever set
 * of accountings is handed in. The scope of that set is the caller's decision:
 * the whole booking, or a single order session.
 */
function sumDiscountEntriesFor(pssUuid: string, accountings: IAccounting[]) {
  const discountAccountings =
    accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT
    ) || [];

  const pssAccountingEntries = discountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat()
    .filter((ae) => ae.productSlotStateUuid === pssUuid);

  return sumArray(pssAccountingEntries.map((ae) => ae.value));
}

export const totalDiscountsByPss = computed((/*pssUuid: string*/) => {
  // We return a function that will do the computation. The function expects an argument
  return (pssUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    return sumDiscountEntriesFor(pssUuid, booking.accountings);
  };
});

/**
 * Discounts on a pss within a single order session.
 *
 * Non-reactive counterpart of {@link totalDiscountsByPss}, for the Belgian
 * receipt, which is a fiscal document for one sale rather than for the booking.
 */
export function totalDiscountsByPssInOrder(
  pssUuid: string,
  pssList: IProductSlotState[],
  accountings: IAccounting[]
) {
  if (!pssList.length) {
    return 0;
  }
  return sumDiscountEntriesFor(pssUuid, accountings);
}

/**
 * Excluded tax on a pss within a single order session.
 *
 * Non-reactive counterpart of {@link excludedTaxByPss}. Not pure — it still
 * reads the pss extension from the store for the tax config.
 */
export function excludedTaxByPssInOrder(
  pssUuid: string,
  pssList: IProductSlotState[],
  accountings: IAccounting[]
) {
  if (!pssList.length) {
    return 0;
  }
  const pss = pssList.find((candidate) => candidate.uuid === pssUuid);
  if (!pss) {
    return 0;
  }
  let taxMicroValue = 0;
  const pssFinalValue =
    getPSSValue(pss) -
    totalDiscountsByPssInOrder(pssUuid, pssList, accountings);
  const taxes = getpssExtension(String(pss.uuid))?.taxes || [];
  if (taxes.length && taxes[0].includedInPrice === 0) {
    taxMicroValue += getTaxValue(pssFinalValue, taxes[0]);
  }
  return taxMicroValue / 10000;
}

/**
 * Discounts on a ticket's automatic addons within a single order session.
 *
 * Non-reactive counterpart of {@link totalAutomaticAddonsDiscounts}. Note the
 * addons are looked up inside the scoped list, so an addon belonging to another
 * order session is not counted.
 */
export function totalAutomaticAddonsDiscountsInOrder(
  pssList: IProductSlotState[],
  accountings: IAccounting[],
  mainTicketUUID: string
) {
  const mainTicket = pssList.find((pss) => pss.uuid === mainTicketUUID);
  if (!mainTicket || !mainTicket.hasAutomaticAddons) {
    return 0;
  }
  const automaticAddons = pssList.filter(
    (pss) => pss.mainTicketUUID === mainTicketUUID
  );
  let total = 0;
  automaticAddons.forEach((addon) => {
    if (addon.uuid) {
      total += totalDiscountsByPssInOrder(addon.uuid, pssList, accountings);
    }
  });
  return total;
}

/**
 * Total of a single order session: the value of its tickets, less its discounts.
 *
 * Non-reactive counterpart of {@link bookingTotalConsideringDiscounts}, with one
 * deliberate difference: a cancelled ticket is **negated** rather than excluded,
 * because a Belgian fiscal receipt has to show the cancellation as a visible
 * negative line. Callers summing VAT must negate cancellation lines to match.
 */
export function currentOrderTotal(
  pssList: IProductSlotState[],
  accountings: IAccounting[]
): number {
  const notAbandonedPssList = pssList.filter(
    (pss) => pss.bookingStatus !== BookingStatus.Abandoned
  );
  if (!notAbandonedPssList.length) {
    return 0;
  }

  const pssSum = Math.round(
    sumArray(
      notAbandonedPssList.map((pss) => {
        const value =
          getPSSValue(pss) +
          excludedTaxByPssInOrder(String(pss.uuid), pssList, accountings) +
          pss.paymentFeeCollected;
        return pss.bookingStatus === BookingStatus.Canceled
          ? value * -1
          : value;
      })
    )
  );

  const discountAccountings =
    accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT
    ) || [];
  const discountSum = sumArray(
    discountAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat()
      .map((ae) => ae.value)
  );

  return pssSum - discountSum;
}

/**
 * genericDiscountsByPss + promocodeDiscountsByPss + offer accountings with Completed state
 */
export const totalDiscountsByPssWithOffersConfirmed = computed(
  (/*pssUuid: string*/) => {
    // We return a function that will do the computation. The function expects an argument
    return (pssUuid: string) => {
      const booking = BookingModule.selectedBooking;
      if (!booking) {
        return 0;
      }
      if (!booking.pssList || !booking.pssList.length) {
        return 0;
      }

      const isInRelevantState = (state: AccountingState) =>
        state === AccountingState.Pending ||
        state === AccountingState.Started ||
        state === AccountingState.Completed;

      const isDiscountTransaction = (acc: IAccounting) =>
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT;

      const isAllowedPosOffer = (acc: IAccounting) =>
        acc.paymentMethod !== PaymentMethods.METHOD_POS_OFFER ||
        (acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER &&
          acc.state === AccountingState.Completed);

      const isAllowedOffer = (acc: IAccounting) =>
        acc.paymentMethod !== PaymentMethods.METHOD_OFFER ||
        (acc.paymentMethod === PaymentMethods.METHOD_OFFER &&
          acc.state === AccountingState.Completed);

      const discountAccountings =
        booking.accountings.filter(
          (acc) =>
            isInRelevantState(acc.state) &&
            isDiscountTransaction(acc) &&
            isAllowedPosOffer(acc) &&
            isAllowedOffer(acc)
        ) || [];

      const accountingsEntries = discountAccountings
        .map((acc) => acc.accountingEntriesList)
        .flat();

      const pssAccountingEntries = accountingsEntries.filter(
        (ae) => ae.productSlotStateUuid === pssUuid
      );

      const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

      return sum;
    };
  }
);

/**
 * returns the sum of discounts (generic + promocode) applied to automatic addons of a given ticket
 */
export function totalAutomaticAddonsDiscounts(
  booking: IProductSlotBooking,
  mainTicketUUID: string
) {
  const pssList = booking.pssList;
  const mainTicket = pssList.find((pss) => pss.uuid === mainTicketUUID);
  if (!mainTicket || !mainTicket.hasAutomaticAddons) {
    return 0;
  }
  const automaticAddons = pssList.filter(
    (pss) => pss.mainTicketUUID === mainTicketUUID
  );
  let total = 0;
  automaticAddons.forEach((addon) => {
    if (addon.uuid) {
      total += totalDiscountsByPss.value(addon.uuid);
    }
  });
  return total;
}

/**
 * We take a pss and return its discounts in a given booking
 * genericDiscountsByPss + promocodeDiscountsByPss
 */
export function totalDiscountsByPssInBooking(
  pssUuid: string,
  bookingCopy: IProductSlotBooking
) {
  if (!bookingCopy?.pssList?.length) {
    return 0;
  }
  return sumDiscountEntriesFor(pssUuid, bookingCopy.accountings);
}

/**
 * sum of accountingEntries values of payment Type accountings and has promocodeId or promocodeUuid and accountingEntry.pssUuid === pssUuid (state:1 or completed)
 */
export const paymentCodesAmountByPss = computed((/*pssUuid: string*/) => {
  // We return a function that will do the computation
  return (pssUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    const paymentCodeAccountings =
      booking.accountings.filter(
        (acc) =>
          (acc.state === AccountingState.Pending ||
            acc.state === AccountingState.Started ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
          (acc.promoCodeId || acc.promoCodeUuid || acc.promocode)
      ) || [];

    const accountingsEntries = paymentCodeAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const pssAccountingEntries = accountingsEntries.filter(
      (ae) => ae.productSlotStateUuid === pssUuid
    );

    const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

    return sum;
  };
});

/**
 * (this includes payment codes) sum of accountingEntries values of payment Type accountings and accountingEntry.pssUuid === pssUuid (state:1 or completed)
 */
export const paymentByPss = computed((/*pssUuid: string*/) => {
  // We return a function that will do the computation
  return (pssUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    // Excluding pending/started accountings coming from backend, the rest will be considered
    // ps: up to now, no scenario generated a pending/started accounting in pos without completing it or removing it
    const paymentAccountings =
      booking.accountings.filter(
        (acc) =>
          ((acc.state === AccountingState.Pending && !acc.id) ||
            (acc.state === AccountingState.Started && !acc.id) ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
      ) || [];

    const accountingsEntries = paymentAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const pssAccountingEntries = accountingsEntries.filter(
      (ae) => ae.productSlotStateUuid === pssUuid
    );

    const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

    return sum;
  };
});

export const refundsByPss = computed((/*pssUuid: string*/) => {
  // We return a function that will do the computation
  return (pssUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    // Excluding pending/started accountings coming from backend, the rest will be considered
    // ps: up to now, no scenario generated a pending/started accounting in pos without completing it or removing it
    const paymentAccountings =
      booking.accountings.filter(
        (acc) =>
          ((acc.state === AccountingState.Pending && !acc.id) ||
            (acc.state === AccountingState.Started && !acc.id) ||
            acc.state === AccountingState.Completed) &&
          acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND
      ) || [];

    const accountingsEntries = paymentAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();

    const pssAccountingEntries = accountingsEntries.filter(
      (ae) => ae.productSlotStateUuid === pssUuid
    );

    const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

    return sum;
  };
});

/**
 * We take a pss and return the sum of its payments in a given booking
 * (this includes payment codes) sum of accountingEntries values of payment Type accountings and accountingEntry.pssUuid === pssUuid (state:1 or completed)
 */
export function paymentByPssInBooking(
  pssUuid: string,
  bookingCopy: IProductSlotBooking
) {
  const booking = bookingCopy;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const paymentAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT
    ) || [];

  const accountingsEntries = paymentAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const pssAccountingEntries = accountingsEntries.filter(
    (ae) => ae.productSlotStateUuid === pssUuid
  );

  const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

  return sum;
}

export function refundsByPssInBooking(
  pssUuid: string,
  bookingCopy: IProductSlotBooking
) {
  const booking = bookingCopy;
  if (!booking) {
    return 0;
  }
  if (!booking.pssList || !booking.pssList.length) {
    return 0;
  }

  const paymentAccountings =
    booking.accountings.filter(
      (acc) =>
        (acc.state === AccountingState.Pending ||
          acc.state === AccountingState.Started ||
          acc.state === AccountingState.Completed) &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND
    ) || [];

  const accountingsEntries = paymentAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  const pssAccountingEntries = accountingsEntries.filter(
    (ae) => ae.productSlotStateUuid === pssUuid
  );

  const sum = sumArray(pssAccountingEntries.map((ae) => ae.value));

  return sum;
}

/**
 * Returns the sum of all payments of the booking (confirmed and pending without id)
 */
export function getPaymentsSum(): number {
  const confirmedAccountings =
    BookingModule.selectedBooking?.accountings.filter(
      (acc) =>
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
        (acc.state === AccountingState.Completed ||
          (!acc.id &&
            acc.state === AccountingState.Pending &&
            (acc.promocode || acc.promoCodeId || acc.promoCodeUuid)))
    );
  let sum = 0;
  if (confirmedAccountings && confirmedAccountings.length) {
    const accEntries = confirmedAccountings
      .map((acc) => acc.accountingEntriesList)
      .flat();
    if (accEntries && accEntries.length) {
      sum = sumArray(accEntries.map((ae) => ae.value));
    }
  }
  return sum;
}

/**
 * returns the excluded tax values for a given pss
 */
export const excludedTaxByPss = computed((/*pssUuid: string*/) => {
  // We return a function that will do the computation. The function expects an argument
  return (pssUuid: string) => {
    const booking = BookingModule.selectedBooking;
    if (!booking) {
      return 0;
    }
    if (!booking.pssList || !booking.pssList.length) {
      return 0;
    }

    const pss = booking.pssList.find((pss) => pss.uuid === pssUuid);
    if (!pss) {
      return 0;
    }
    let taxMicroValue = 0;
    const pssValue = getPSSValue(pss);
    const pssFinalValue =
      pssValue - totalDiscountsByPss.value(String(pss.uuid));
    const taxes = getpssExtension(String(pss.uuid))?.taxes || [];
    if (taxes.length && taxes[0].includedInPrice === 0) {
      taxMicroValue += getTaxValue(pssFinalValue, taxes[0]);
    }
    return taxMicroValue / 10000;
  };
});

/**
 * returns the total tax value of the booking
 */
export const bookingTotalTax = computed(() => {
  const booking = BookingModule.selectedBooking;
  if (!booking) {
    return 0;
  }
  const pssList = booking.pssList;
  let totalTaxMicroValue = 0;
  for (let i = 0; i < pssList.length; i++) {
    if (
      pssList[i].bookingStatus === BookingStatus.Canceled ||
      pssList[i].bookingStatus === BookingStatus.Abandoned
    ) {
      continue;
    }
    const pssValue = getPSSValue(pssList[i]);
    const pssFinalValue =
      pssValue - totalDiscountsByPss.value(String(pssList[i].uuid));

    const taxes = getpssExtension(String(pssList[i].uuid))?.taxes || [];
    if (taxes.length) {
      totalTaxMicroValue += getTaxValue(pssFinalValue, taxes[0]);
    }
  }
  return Math.round(totalTaxMicroValue / 10000);
});

/**
 * returns the excluded tax values for a given pss
 */
export const excludedTaxByPssInBooking = computed(
  (/*pssUuid: string, bookingCopy: IProductSlotBooking*/) => {
    // We return a function that will do the computation. The function expects an argument
    return (pssUuid: string, booking: IProductSlotBooking) => {
      if (!booking) {
        return 0;
      }
      if (!booking.pssList || !booking.pssList.length) {
        return 0;
      }

      const pss = booking.pssList.find((pss) => pss.uuid === pssUuid);
      if (!pss) {
        return 0;
      }
      let taxMicroValue = 0;
      const pssValue = getPSSValue(pss);
      const pssFinalValue =
        pssValue - totalDiscountsByPssInBooking(pssUuid, booking);
      const taxes = getpssExtension(pssUuid)?.taxes || [];
      if (taxes.length && taxes[0].includedInPrice === 0) {
        taxMicroValue += getTaxValue(pssFinalValue, taxes[0]);
      }
      return taxMicroValue / 10000;
    };
  }
);

/**
 * Returns the most recently created adyen accounting that is not coming from backend, or in a Completed/Failed state
 */
export function getMostRecentAdyenAccounting(accountings: IAccounting[]) {
  // We should explicitly extract the accounting that we're going now to pay
  // we ignore failed adyen accountings
  // we ignore accountings coming from backend
  const adyenUncompletedAccountings = accountings.filter(
    (acc) =>
      !acc.id &&
      acc.state !== AccountingState.Completed &&
      acc.state !== AccountingState.Failed &&
      acc.paymentMethod === PaymentMethods.METHOD_POS_ADYEN
  );
  // Lets sort them by their creationDate and take the last created one (first one in the array)
  adyenUncompletedAccountings.sort((acc1, acc2) => {
    const time1 = dayjs(acc1.createdAt).toDate().toISOString();
    const time2 = dayjs(acc2.createdAt).toDate().toISOString();
    if (time1 > time2) {
      return -1;
    }
    if (time1 < time2) {
      return 1;
    }
    // times must be equal
    return 0;
  });
  return adyenUncompletedAccountings[0];
}

/**
 * Gets the sum of transaction type discount accounting entries applied on a ticket group
 * @param pssGroup - ticket group to check
 * @param excludeRefunded - if true, excludes refunded accountings, defaults to false to preserve any current behavior
 */
export function getPssGroupDiscount(
  pssGroup: IQuantifiedProductSlotState,
  excludeRefunded = true
) {
  // all pss that are concerned in discount/promocodeDiscount
  let discountAccEntries: IAccountingEntry[] = [];
  const discountAccountings = BookingModule.selectedBooking?.accountings.filter(
    (acc) =>
      (!excludeRefunded || !acc.refund) &&
      acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT &&
      (acc.state === AccountingState.Completed ||
        acc.state === AccountingState.Pending)
  );
  if (!discountAccountings || !discountAccountings.length) {
    // there are no discount accountings
    return 0;
  }

  discountAccEntries = discountAccountings
    .map((acc) => acc.accountingEntriesList)
    .flat();

  // a list of the uuids of the pssGroup
  const rowPssListUuids = pssGroup.pssIds;
  // list of pss from the pssGroup and that are considered in the discount/promocodeDiscount
  const filteredPssDiscounts = discountAccEntries.filter((ae) =>
    rowPssListUuids.some((element) => element === ae.productSlotStateUuid)
  );
  if (filteredPssDiscounts && filteredPssDiscounts.length) {
    const pssGroupDiscountsSum = sumArray(
      filteredPssDiscounts.map((it) => it.value)
    );
    return pssGroupDiscountsSum;
  }
  return 0;
}

export function createOffersDiscountAccounting(data: {
  booking: IProductSlotBooking;
  applicationUuid?: string;
  pssDiscountInfo: {
    applicationDetailPss: IProductSlotState[];
    valueInCents: number;
  }[];
  offerId: number;
  code?: string;
  codeId?: number;
}) {
  const { booking, applicationUuid, pssDiscountInfo, offerId, code, codeId } =
    data;
  const uuid = applicationUuid || generateID();
  const creationTime = dayjs().toISOString();
  const accountingState = AccountingState.Pending;
  const transactionType = TransactionTypes.TRANSACTION_TYPE_DISCOUNT;

  // link the transaction to the new accounting
  const transaction =
    FiskalyModule.transactionsInProgress[String(booking.uuid)];

  const accounting: IAccounting = {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: accountingState,
    transactionType: transactionType,
    paymentMethod: PaymentMethods.METHOD_POS_OFFER,
    bookingUuid: booking.uuid,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: booking.currency,
    accountingEntriesList: [],
    cashRegisterId: "",
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    fiskalyTransactionUuid: transaction ? transaction.uuid : null,
    promocode: code,
    promoCodeId: codeId,
    promoCodeUuid: code,
  };

  // Create accounting entries for the tickets with discount

  for (let i = 0; i < pssDiscountInfo.length; i++) {
    const { applicationDetailPss: pssToDiscount, valueInCents } =
      pssDiscountInfo[i];

    for (let j = 0; j < pssToDiscount.length; j++) {
      const pss = pssToDiscount[j];
      if (isPSSPaid(pss)) {
        // PSS already paid; it will not be considered in discount accounting
        continue;
      }

      const now = nowDB();
      const accountingEntryValue = valueInCents;
      const accountingEntry: IAccountingEntry = {
        _id: generateID(),
        uuid: generateID(),
        accountingUuid: accounting.uuid,
        orderSessionId: String(BookingModule.currentOrderSessionId),
        productSlotStateUuid: pss.uuid,
        value: accountingEntryValue,

        groupId: Number(pss.productOwnerGroupId),
        bookingStatementVersion: 2,
        createdAt: now,
        updatedAt: now,

        productId: pss.productId,
        offerId,
      };

      if (pss.id) {
        accountingEntry.productSlotStateId = pss.id;
      }

      // new tax logic
      const priceTaxes = getpssExtension(String(pss.uuid))?.taxes || [];
      if (priceTaxes.length) {
        const tax = priceTaxes[0];
        accountingEntry.salesTaxMicroValue = getTaxValue(
          accountingEntry.value,
          tax
        );
        accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
        accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
        accountingEntry.taxId = Number(tax.id);
      }

      accounting.accountingEntriesList.push(accountingEntry);
    }
  }

  return accounting;
}

/**
 * Marks pending promocode-related accountings as failed instead.
 * @param bookingCopy
 */
export function failAllPendingCodeAccountings(
  bookingCopy: IProductSlotBooking
) {
  bookingCopy.accountings.forEach((acc) => {
    const isPendingPromocodePayment =
      (acc.promoCodeUuid || acc.promocode) &&
      !acc.refund &&
      acc.state === AccountingState.Pending &&
      !acc.isExternalVoucherService;
    if (isPendingPromocodePayment) {
      acc.state = AccountingState.Failed;
    }
  });
}

/**
 * Finds the most recent POS_ADYEN accounting and marks it as failed
 * Used to abort payments that will not be initiated.
 */
export function failLatestAdyenAccounting(booking: IProductSlotBooking | null) {
  if (!booking) {
    return;
  }
  const accountings = [...booking.accountings];
  const mostRecentAccounting = getMostRecentAdyenAccounting(accountings);
  const accountingIndex = accountings.findIndex(
    (acc) => acc.uuid === mostRecentAccounting.uuid
  );
  if (accountingIndex !== -1) {
    accountings[accountingIndex].state = AccountingState.Failed;
    BookingModule.updateBookingAccountings({
      bookingUUID: booking.uuid as string,
      accountings: accountings,
    });
  }
}

/**
 * Builds the common shell of a Belgian cash-rounding accounting.
 *
 * The rounding difference is booked as its own payment line so the exact sale
 * total and the rounded cash actually handed over both stay on the record.
 */
function buildCashRoundingAccounting(
  booking: IProductSlotBooking,
  transactionType: TransactionTypes,
  isRefund: boolean
): IAccounting {
  const creationTime = dayjs().toISOString();
  const uuid = generateID();

  // link the transaction to the new accounting
  const transaction =
    FiskalyModule.transactionsInProgress[String(booking.uuid)];

  return {
    _id: uuid,
    uuid: uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    state: AccountingState.Pending,
    transactionType,
    paymentMethod: PaymentMethods.METHOD_CASH_ROUNDING,
    paymentCurrency: booking.currency,
    bookingUuid: booking.uuid,
    createdAt: creationTime,
    updatedAt: creationTime,
    message: creationTime + " :: accounting was created.",
    isDeposit: false,
    currency: booking.currency,
    accountingEntriesList: [],
    cashRegisterId: "",
    channel: "Smeetz POS",
    merchantReference: "",
    CfUid: CashFloatModule.cashFloat?.uid,
    createdBy: AuthModule.cognitoId,
    fiskalyTransactionUuid: transaction ? transaction.uuid : null,
    ...(isRefund ? { refund: 1 } : {}),
  };
}

/**
 * Builds the single entry a cash-rounding accounting carries, attached to the
 * pss the rounding is attributed to.
 */
function buildCashRoundingEntry(
  accounting: IAccounting,
  pss: IProductSlotState,
  roundingAmount: number
): IAccountingEntry {
  const now = nowDB();
  const accountingEntry: IAccountingEntry = {
    _id: generateID(),
    uuid: generateID(),
    accountingUuid: accounting.uuid,
    orderSessionId: String(BookingModule.currentOrderSessionId),
    productSlotStateUuid: pss.uuid,
    value: roundingAmount,

    groupId: Number(pss.productOwnerGroupId),
    bookingStatementVersion: 2,
    createdAt: now,
    updatedAt: now,

    productId: pss.productId,
  };

  if (pss.id) {
    accountingEntry.productSlotStateId = pss.id;
  }

  return accountingEntry;
}

/**
 * Creates the payment-side cash-rounding accounting for a Belgian sale.
 *
 * @param roundingAmount difference in cents, signed
 * @returns the accounting, or null when no pss can carry the rounding
 */
export function createCashRoundingAccounting(
  booking: IProductSlotBooking,
  roundingAmount: number
): IAccounting | null {
  const accounting = buildCashRoundingAccounting(
    booking,
    TransactionTypes.TRANSACTION_TYPE_PAYMENT,
    false
  );

  // attribute the rounding to the first pss still being paid for
  const pss = booking.pssList.find(
    (candidate) =>
      !isPSSPaid(candidate) &&
      candidate.bookingStatus !== BookingStatus.Canceled &&
      candidate.bookingStatus !== BookingStatus.Abandoned
  );
  if (!pss) {
    return null;
  }

  const accountingEntry = buildCashRoundingEntry(
    accounting,
    pss,
    roundingAmount
  );

  // new tax logic
  const priceTaxes = getpssExtension(String(pss.uuid))?.taxes || [];
  if (priceTaxes.length) {
    const tax = priceTaxes[0];
    accountingEntry.salesTaxMicroValue = getTaxValue(
      accountingEntry.value,
      tax
    );
    accountingEntry.salesTaxRate = Number(tax.rateMiliValue);
    accountingEntry.salesTaxIncluded = Number(tax.includedInPrice);
    accountingEntry.taxId = Number(tax.id);
  }

  accounting.accountingEntriesList.push(accountingEntry);

  return accounting;
}

/**
 * Creates the refund-side cash-rounding accounting for a Belgian refund.
 *
 * Unlike the payment side this carries no tax fields: the tax was already
 * accounted for on the original sale.
 *
 * @param roundingAmount difference in cents, signed
 * @returns the accounting, or null when there is no pss to attach it to
 */
export function createCashRoundingRefundAccounting(
  booking: IProductSlotBooking,
  roundingAmount: number,
  pssList: IProductSlotState[]
): IAccounting | null {
  const pss = pssList[0];
  if (!pss) {
    return null;
  }

  const accounting = buildCashRoundingAccounting(
    booking,
    TransactionTypes.TRANSACTION_TYPE_REFUND,
    true
  );

  accounting.accountingEntriesList.push(
    buildCashRoundingEntry(accounting, pss, roundingAmount)
  );

  return accounting;
}
